import { Turbo } from "@hotwired/turbo-rails";

// Re-renders the navigation menu (answered as a Turbo Stream by dashboard#menu).
export function refreshMenu(url) {
  return fetch(url, {headers: {Accept: "text/vnd.turbo-stream.html"}, credentials: "same-origin"})
    .then((response) => response.text())
    .then((html) => Turbo.renderStreamMessage(html));
}
